import React from 'react';
import { Box, Typography } from '@mui/material';
import { displayValue, getDataValue, isBlank, latestEntry } from '../utils';

const Settings = {
  Name: 'Value',
  Display: true,
  options: {
    view: null,
    settings: [
      { id: 'valueName', type: 'text', name: 'Name' },
      { id: 'dataId', type: 'text', name: 'Data path', placeholder: 'temperature or body.temperature' },
      { id: 'unit', type: 'text', name: 'Unit' },
      { id: 'emptyText', type: 'text', name: 'Empty text', default: 'Unknown' },
    ],
    grid: true,
  },
};

const View = ({ DeviceData, Settings: userSettings = {} }) => {
  const entry = latestEntry(DeviceData);
  const value = getDataValue(entry, userSettings.dataId);
  const isMissing = isBlank(value);

  return (
    <Box>
      {userSettings.valueName ? (
        <Typography component="strong" sx={{ fontWeight: 700 }}>
          {userSettings.valueName}: {' '}
        </Typography>
      ) : null}
      <Typography component="span">
        {displayValue(value, userSettings.emptyText || 'Unknown')}
        {!isMissing && userSettings.unit ? ` ${userSettings.unit}` : ''}
      </Typography>
    </Box>
  );
};

export default {
  Settings,
  View,
};
